import React from "react";

export default function MenuToggle() {

    return (
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
                aria-controls="navbarCollapse" aria-expanded="false"
                aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"/>
        </button>
    );
}